module.exports = __webpack_public_path__ + "static/01-4704a839f7ed4600550019dd4c2fab9a.jpg";